import React from 'react';
import '../Deliveryifo/Deliveryifo.css'

const Deliveryifo = () => {
  return (
    <div className='section delivery-info'>
        <div className="container">
            <div className="grid-container">
               <h4>Additional <span>information</span></h4>
               <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Non temporibus excepturi nostrum obcaecati! Optio rerum quod amet ducimus tempore repellat est doloribus temporibus voluptatem animi, dolor modi ratione in neque.</p>
            </div>
        </div>
    </div>
  )
}

export default Deliveryifo